<template>
  <div class="container p-3">
    <h2 class="title-blue mb-3 text-center">{{ t("UPDATE_PERSONAL_DATA") }}</h2>
    <div class="row justify-content-center">
      <div class="col-xl-6">
        <profile-form create-new-token-on-update show-unconfirmed-email-alert is-profile-update/>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import ProfileForm from "@/views/components/forms/ProfileForm.vue";
import {useI18n} from "vue-i18n";

const {t} = useI18n();
</script>
